<template>
    <div class="text-center">
        <el-button-group>
            <el-tooltip class="item" v-if="cat.isActive" effect="dark" content="Guardar cambios" placement="top-end">
                <el-button type="primary" icon="far fa-save" size="small" @click="saveCat"></el-button>
            </el-tooltip>
            <el-tooltip class="item" v-if="cat.isActive == false" effect="dark"
                        content="Activar Este Registro en Catálogo" placement="top-end">
                <el-button type="success" icon="el-icon-success" size="small" @click="activateCat"></el-button>
            </el-tooltip>
            <el-tooltip class="item" v-if="cat.isActive == true" effect="dark" content="Desactivar Rubro en Catálogo"
                        placement="top-end">
                <el-button type="danger" icon="el-icon-error" size="small" @click="deactivateCat"></el-button>
            </el-tooltip>
        </el-button-group>
    </div>
</template>

<script>
    export default {
        props: {
            cat: {
                type: Object,
                required: true
            },

            aliasRef: {},
            alias_this: {},
            methodReload: {
                type: Function
            },

        },

        methods: {
            saveCat() {
                if (this.aliasRef) {
                    this.alias_this.$refs[this.aliasRef].validate((valid) => {
                        if (valid) {
                            this.saveService();
                        } else {
                            this.$store.dispatch('notifications/error', {msg: 'Verifique campos requeridos.'}, {root: true});
                            return false;
                        }
                    });
                } else {
                    this.saveService();
                }
            },

            activateCat() {

                let _this = this;
                let _data = {
                    catalog: _this.cat.model_name
                };
                _this.$confirm('¿Desea activar este rubro en el Catálogo?').then(confirm => {
                    axios.post(`/api/catalogs/activate/${_this.cat.hash_id? _this.cat.hash_id: _this.cat.crypt_id}`, _data).then(response => {
                        if (response.data.success) {
                            this.$store.dispatch('notifications/ok', {msg: 'Rubro activado correctamente.'}, {root: true});
                            this.cat.isActive = 1;
                            _this.alias_this.getCatalog(this.cat.model_name);
                        }
                        else {
                            this.$store.dispatch('notifications/error', {msg: 'Error al activar'}, {root: true});
                        }
                    }).catch(_ => {
                        this.$store.dispatch('notifications/error', {msg: 'No se pudo  completar la solicitud'}, {root: true});
                    });
                }).catch(e => {
                    this.$store.dispatch('notifications/warning', {msg: 'No se registró ningun cambio.'}, {root: true});
                });
            },

            deactivateCat() {
                let _this = this;

                _this.$confirm('¿Desea desactivar este rubro en el Catálogo?').then(confirm => {
                    axios.delete(`/api/catalogs/${_this.cat.hash_id? _this.cat.hash_id: _this.cat.crypt_id}`, {params: {catalog: _this.cat.model_name}}).then(response => {
                        if (response.data.success) {
                            this.$store.dispatch('notifications/ok', {msg: 'Rubro Desactivado'}, {root: true});
                            _this.alias_this.addSubBudget = false;
                            _this.alias_this.modalSubBudget = false;
                            _this.alias_this.modalProduct = false;
                            _this.alias_this.modalCurrency = false;
                            _this.alias_this.modalOffice = false;
                            _this.alias_this.getCatalog(this.cat.model_name);
                        }
                        else {
                            this.$store.dispatch('notifications/error', {msg: 'Error al desactivar'}, {root: true});
                        }
                    }).catch(_ => {
                        this.$store.dispatch('notifications/error', {msg: 'No se pudo completar la solicitud'}, {root: true});
                    });
                }).catch(e => {
                    this.$store.dispatch('notifications/warning', {msg: 'No se registró ningun cambio.'}, {root: true});
                });
            },

            saveService() {

                let _this = this;

                let catForm = {
                    ..._this.cat,
                    catalog: _this.cat.model_name,

                };
                if (_this.cat.model_name != '') {
                    axios.put(`/api/catalogs/${catForm.hash_id? catForm.hash_id: catForm.crypt_id}`, catForm).then(response => {
                        _this.$store.dispatch('loading/spinner', {}, {root: true});
                        if (response.data.success) {
                            this.$store.dispatch('notifications/ok', {msg: 'Actualización de catálogo correcta'}, {root: true});
                            _this.alias_this.addSubBudget = false;
                            _this.alias_this.modalSubBudget = false;
                            _this.alias_this.modalProduct = false;
                            _this.alias_this.modalCurrency = false;
                            _this.alias_this.modalOffice = false;
                            _this.alias_this.modalService = false;
                            _this.alias_this.modalRegion = false;
                            _this.alias_this.getCatalog(this.cat.model_name);
                        }
                        else {
                            this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                        }
                    }).catch(error => {
                        console.log(error);
                        this.$store.dispatch('notifications/error', {msg: 'El valor nuevo que desea ingresar, ya se encuentra en el catálogo, verifique y trate nuevamente.'}, {root: true});
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>